// Full-bleed on mobile, so the image is viewport-wide. The desktop hero's formula
// subtracts a sidebar that doesn't exist here and resolves negative on phones (CON-8444).
// Scaled by zoom to fetch a bigger candidate; the browser applies DPR itself.
const getMobileGallerySizes = (zoom = 1) => `${Math.round(100 * zoom)}vw`;

export default getMobileGallerySizes;
